<template>
  <div class="settled-enterprise">
    <div class="settled-enterprise-col" v-for="(items, index) in reverseList" :key="index">
      <div class="time">{{items.key}}</div>
      <div class="enterprise-list">
        <div v-for="item in items.value" :key="item.coName">{{item.coName}}</div>
      </div>
    </div>
    <!-- <div class="settled-enterprise-col" v-for="(items, index) in listData" :key="index">
      <div class="time">{{index}}</div>
      <div class="enterprise-list">
        <div v-for="item in items" :key="item.coName">{{item.coName}}</div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    listData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    reverseList() {
      let obj = this.listData
      if (obj) {
        // 使用Object.entries()获取键值对数组  
        const entries = Object.entries(obj);  
        
        // 创建一个新的数组对象，其中每个元素都是一个包含key和value的对象  
        const arrayOfObjects = entries.map(([key, value]) => ({ key, value })).reverse(); 
        return arrayOfObjects
      } else {
        return []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.settled-enterprise {
  padding-top: 5px;
  .settled-enterprise-col {
    display: flex;
    .time {
      width: 150px;
      height: 25px;
      padding-left: 15px;
      box-sizing: border-box;
      color: #fff;
      font-size: 18px;
      background: url("~@/assets/images/bigScreen/bg-sjx.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      margin-top: 6px;
    }
    .enterprise-list {
      flex: 1;
      padding-left: 10px;
      border-left: 2px solid #CAE1FB;
      position: relative;
      > div{
        background: linear-gradient(to left, rgba(28,52,78,0.7), rgba(26,47,67,0.3));
        color: 0.2rem;
        font-size: 15px;
        padding: 0.05rem 0.1rem;
        margin-bottom: 5px;
        box-sizing: border-box;
        color: #E9F5FF;
      }
      &:before {
        left: -13px;
        top: 8px;
        position: absolute;
        display: block;
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 50%;
        background: #CAE1FB;
        content: '';
      }
    }
  }
}
</style>